import ApiProject from "../../../../../../core/gd/api/project"
import {ProjectSystemType} from "../../../../../../core/model2/project/types"
import {ViewType} from "../../../../../../core/gd/const/views/view-type"
import ProjectSession from "../../../../../../core/model2/project/project-session"

type APICallParams = {
    systemType          : ProjectSystemType
    viewType            : ViewType
    parentProjectId?    : ID
    name                : string
    color?              : number
    projectIcon?        : string
}

export default async function menuAdd_createProductivity(params: APICallParams) : Promise<ProjectSession> {

    const data: any = await ApiProject.newResource({
        parentProjectId         : params.parentProjectId,
        systemType              : params.systemType,
        name                    : params.name,
        color                   : params.color,
        settings                : {
            views                   : [
                {
                    "id"            : gd.utils.generateUIDWithCollisionChecking(),
                    "systemType"    : params.viewType,
                    "name"          : params.name,
                    "userId"        : gd.user.id,
                    "sortPosition"  : 0
                }
            ]
        },
        projectIcon             : params.projectIcon // ProjectIconDictionary[project.projectIcon as keyof object]
    }).promise()


    switch (params.viewType) {
        case ViewType.PROJECT_EXPENSES:
            await gd.api.Project.setProperties(data.projectId, {expenses: true}).promise()
            break
    }

    return gd.session.projects.get(data.projectId)!
}